import UserAPIs, { iUpdateAccountLanguageParams } from "../../apis/user.apis";
import i18n, { EW_I18N_LOCALES, EW_I18N_STORAGE_KEY, ensureLocaleLoaded, resolveEwDisplayLocaleCode } from "../../i18n";
import { seedWidgetFormCopy } from "../../utils/widgetFormCopyLoad";

const SUPPORTED = new Set<string>(EW_I18N_LOCALES.map((l) => l.code));

function persistLanguageOnServer(payload: iUpdateAccountLanguageParams) {
    if (!payload.language_id && !payload.language) {
        return;
    }

    new UserAPIs()
        .update_account_language(payload)
        .then((response) => {
            if (response.statusCode === 401 || response.statusCode === 403) {
                return;
            }
            if (UserAPIs.hasErrorNotification(response)) {
                /* UI locale already updated locally */
                return;
            }
            const code =
                resolveEwDisplayLocaleCode(response.language?.code) ||
                resolveEwDisplayLocaleCode(payload.language) ||
                "";
            if (code && response.widget_copy) {
                seedWidgetFormCopy(code, response.widget_copy);
            }
        });
}

/**
 * Switch dashboard / shop UI locale and persist to `POST /account/language`.
 * Prefer `languageId` (matches `/account/languages`); fall back to `code` for header menu, etc.
 * Does not rewrite chat/review widget form copy — those use their own `form_language`.
 */
export function setAppLanguage(code: string, languageId?: string | number) {
    const uiCode = resolveEwDisplayLocaleCode(code) || code;
    if (SUPPORTED.has(uiCode)) {
        void ensureLocaleLoaded(uiCode).then(() => i18n.changeLanguage(uiCode));
        try {
            localStorage.setItem(EW_I18N_STORAGE_KEY, uiCode);
        } catch {
            /* ignore */
        }
    }

    const payload: iUpdateAccountLanguageParams = {};
    if (languageId !== undefined && languageId !== "") {
        payload.language_id = languageId;
    } else if (code) {
        payload.language = code;
    }
    persistLanguageOnServer(payload);
}
